import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { AppAuthProvider } from './utils/authProvider'
import { GraphQLProvider } from './utils/Apollo'
import './i18n'
import ApplicationInsights from './utils/applicationinsights'

function app() {
  function RenderProvider() {
    return (
      <React.StrictMode>
        <AppAuthProvider>
          <GraphQLProvider>
            <App />
          </GraphQLProvider>
        </AppAuthProvider>
      </React.StrictMode>
    )
  }

  function RenderDom() {
    return <ApplicationInsights>{RenderProvider()}</ApplicationInsights>
  }

  const rootElement = document.getElementById('root')

  const root = ReactDOM.createRoot(rootElement as HTMLElement)

  root.render(RenderDom())
}

app()

serviceWorker.unregister()
